import React from 'react';
import { motion } from 'framer-motion';
import { Sliders, ShieldCheck, Droplets } from 'lucide-react';
export function DifferentiatorSection() {
  const cards = [{
    icon: <Sliders className="w-8 h-8 text-gold-500" data-id="element-46" />,
    title: 'Sensación estimulante + control',
    desc: 'A diferencia de los geles anestésicos que "apagan" todo, el Gel Gold trabaja en intensificar la experiencia manteniendo sensación.'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-gold-500" data-id="element-47" />,
    title: 'Compatible con preservativos',
    desc: 'No daña látex ni materiales sintéticos. Podés usarlo con tranquilidad.'
  }, {
    icon: <Droplets className="w-8 h-8 text-gold-500" data-id="element-48" />,
    title: 'Fácil de aplicar',
    desc: 'Se absorbe rápido, no deja residuos pegajosos ni olor fuerte.'
  }];
  return <section className="w-full bg-dark-800 py-24 px-4" data-id="element-49">
      <div className="max-w-5xl mx-auto" data-id="element-50">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-52">
            QUÉ LO HACE DIFERENTE
          </h2>
          <div className="w-20 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-53" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-54">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-dark-700 p-8 rounded-2xl border border-white/5 flex flex-col items-center text-center hover:shadow-gold-glow/10 transition-shadow duration-300" data-id="element-55">
              <div className="mb-6 p-4 bg-dark-900 rounded-full border border-gold-500/20" data-id="element-56">
                {card.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-57">
                {card.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-58">{card.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}